import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const ParcaEsleme = () => {
  const [kayitlar, setKayitlar] = useState([]);
  const [arama, setArama] = useState('');
  const [sonuclar, setSonuclar] = useState([]);

  useEffect(() => {
    const veri = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setKayitlar(veri);
  }, []);

  const eslestir = () => {
    const sonuc = [];

    kayitlar.forEach((kayit) => {
      Object.entries(kayit.parcalar || {}).forEach(([parcaTuru, tedarikciler]) => {
        tedarikciler.forEach((tedarikci) => {
          if (
            parcaTuru.toLowerCase().includes(arama.toLowerCase()) ||
            tedarikci.adi.toLowerCase().includes(arama.toLowerCase()) ||
            tedarikci.kod.toLowerCase().includes(arama.toLowerCase())
          ) {
            sonuc.push({
              firma: kayit.firma,
              model: kayit.model,
              seriNo: kayit.seriNo,
              parcaTuru,
              ...tedarikci,
            });
          }
        });
      });
    });

    setSonuclar(sonuc);
  };

  return (
    <div className="max-w-5xl mx-auto p-4">
      <Card>
        <CardContent className="space-y-4">
          <h2 className="text-2xl font-bold">🤖 AI Parça Eşleme</h2>
          <div className="flex gap-2">
            <Input
              placeholder="Parça adı, tedarikçi veya kod ara..."
              value={arama}
              onChange={(e) => setArama(e.target.value)}
            />
            <Button onClick={eslestir}>Eşleştir</Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {sonuclar.map((item, i) => (
              <div key={i} className="border p-3 rounded shadow bg-white">
                <p><strong>Firma:</strong> {item.firma}</p>
                <p><strong>Model:</strong> {item.model}</p>
                <p><strong>Seri No:</strong> {item.seriNo}</p>
                <p><strong>Parça:</strong> {item.parcaTuru}</p>
                <p><strong>Tedarikçi:</strong> {item.adi}</p>
                <p><strong>Kod:</strong> {item.kod}</p>
                <p><strong>Fiyat:</strong> {item.fiyat} €</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ParcaEsleme;
